import React from 'react';
import { PollarLogoSVG } from '@/constants/logo';

/**
 * Pollar Brand Component - Displays logo + brand name
 * Use this component for consistent branding across the app
 */
export const PollarBrand = ({ 
  size = 'medium', 
  showText = true, 
  className = '',
  textClassName = '',
  logoClassName = '',
  onClick = null
}) => {
  const sizes = {
    small: {
      logo: 'w-6 h-6',
      text: 'text-lg',
      container: 'gap-2'
    },
    medium: {
      logo: 'w-10 h-10',
      text: 'text-2xl',
      container: 'gap-3'
    },
    large: {
      logo: 'w-16 h-16',
      text: 'text-4xl',
      container: 'gap-4'
    }
  };

  const sizeConfig = sizes[size] || sizes.medium;

  return (
    <div 
      className={`flex items-center ${sizeConfig.container} ${className} ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <PollarLogoSVG className={`${sizeConfig.logo} ${logoClassName}`} />
      {showText && (
        <span className={`font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent ${sizeConfig.text} ${textClassName}`}>
          Pollar
        </span>
      )}
    </div>
  );
};

/**
 * Pollar Brand Header - For use in page headers
 */
export const PollarBrandHeader = ({ className = '' }) => {
  return (
    <div className={`flex items-center justify-center py-4 ${className}`}>
      <PollarBrand size="medium" />
    </div>
  );
};

/**
 * Pollar Brand Mini - For navbars and compact spaces
 */
export const PollarBrandMini = ({ className = '' }) => {
  return <PollarBrand size="small" showText={true} className={className} />;
};

export default PollarBrand;
